export const HIDDEN_SUBJECT = 'hidden';
export const STATIC_SUBJECT = 'static';
export const EDITABLE_SUBJECT = 'editable';
